import { apiClient } from '@/lib/api/client';
import { env } from '@/lib/env';

export const authApi = {
  // Redirect to backend Auth0 login endpoint
  login: () => {
    window.location.href = `${env.VITE_API_BASE_URL}/api/v1/auth/login`;
  },

  // Call backend logout endpoint to clear cookie
  logout: async () => {
    try {
      const response = await apiClient.POST('/api/v1/auth/logout', {});
      // Redirect to Auth0 logout URL if provided
      if (response.data?.data?.logout_url) {
        window.location.href = response.data.data.logout_url;
      } else {
        window.location.href = '/login';
      }
    } catch {
      // Fallback: redirect to login
      window.location.href = '/login';
    }
  },

  // Get current user profile (validates session via cookies)
  getProfile: () => apiClient.GET('/api/v1/auth/user'),
};
